import { createFeatureSelector, MemoizedSelector } from '@ngrx/store'; // MemoizedSelector - for build
import { CartState } from './cart.reducer';

export const getCartState: MemoizedSelector<CartState, CartState> = createFeatureSelector<CartState>('cart');
